<div class="action-main-container">  
    <!-- Placeholder for global filter -->
    <div class="ltms-tabs">
        <span class="ltms-tab" *ngIf="tabVisiblity.status_overview" [ngClass]="{ 'ltms-active-tab': activeTab === 'status_overview' }" (click)="toggleTab('status_overview')">Status Overview</span>
        <span class="ltms-tab" *ngIf="tabVisiblity.open_actionables" [ngClass]="{ 'ltms-active-tab': activeTab === 'open_actionables' }" (click)="toggleTab('open_actionables')">Open Actionables</span>
        <span class="ltms-tab" *ngIf="tabVisiblity.closed_actionables" [ngClass]="{ 'ltms-active-tab': activeTab === 'closed_actionables' }" (click)="toggleTab('closed_actionables')">Closed Actionables</span>
    </div>
    <div>
        <div *ngIf="activeTab === 'status_overview' && tabVisiblity.status_overview">
            <app-project-action-summary-home></app-project-action-summary-home>
        </div>
        <div *ngIf="activeTab === 'open_actionables' && tabVisiblity.open_actionables">
            <app-project-action-ageing-home></app-project-action-ageing-home>
        </div>
        <div *ngIf="activeTab === 'closed_actionables' && tabVisiblity.closed_actionables">
            <app-project-action-tat-home></app-project-action-tat-home>
        </div>
    </div>
</div>
  